

















































































































































import { Vue } from "vue-property-decorator";
import { Individu } from "../../../models/Individu";
import { utils } from "@/util";
import AppIcon from "@/components/app-icon.vue";
import { Autorisations } from "@/models/Autorisations";


export default Vue.extend({
  props: {
    enfant: {
      type: Individu,
    },
    currentEtablissement: {
      type: Object,
    },
    autori: {
      type: Number,
      default: -2,
    },
  },
  components: {
    AppIcon,
  },

  data() {
    return {};
  },
  filters: {
    inverseDate: (datenaissance: string) => {
      if (!datenaissance) return "";
      let d = utils.getDateFromString(datenaissance, "YYYY-MM-DD");
      return "Né le " + d.format("DD-MM-YYYY");
    },
  },
  methods: {
    affichageEdition(id: string) {
      let autorisations: Array<Autorisations> =
        this.enfant.getListeAutorisations();
      autorisations = autorisations.filter(
        (item: any) => item.typeautorisation_id === id && item.mobi
      );
      if (typeof autorisations === "undefined" || autorisations.length === 0) {
        return 0;
      } else {
        return autorisations[0].getAffichageedition();
      }
    },
    getRegimSrc() {
      if (
        this.enfant
          .getRegimeAlimentaireIndividu()
          .getVieQuoRegimeAli()
          .getType_regime() === "Autre"
      )
        return "/assets/information/regime/REG_ALIM_AUTRE_LISTE_NOM.svg";
      if (
        this.enfant
          .getRegimeAlimentaireIndividu()
          .getVieQuoRegimeAli()
          .getType_regime() === "Sans porc"
      )
        return "/assets/information/regime/REG_ALIM_SANS_PORC.svg";
      else if (
        this.enfant
          .getRegimeAlimentaireIndividu()
          .getVieQuoRegimeAli()
          .getType_regime() === "Sans viande"
      )
        return "/assets/information/regime/REG_ALIM_SANS_VIANDE.svg";
      else if (
        this.enfant
          .getRegimeAlimentaireIndividu()
          .getVieQuoRegimeAli()
          .getType_regime() === "Végétarien"
      )
        return "/assets/information/regime/REG_ALIM_VEGETARIEN.svg";
      else if (
        this.enfant
          .getRegimeAlimentaireIndividu()
          .getVieQuoRegimeAli()
          .getType_regime() === "Sans gluten"
      )
        return "/assets/information/regime/REG_ALIM_SANS_GLUTEN.svg";
      else if (
        this.enfant
          .getRegimeAlimentaireIndividu()
          .getVieQuoRegimeAli()
          .getType_regime() === "PAI"
      )
        return "/assets/information/regime/REG_ALIM_PAI.svg";
      else if (
        this.enfant
          .getRegimeAlimentaireIndividu()
          .getVieQuoRegimeAli()
          .getType_regime() === "Sans régime"
      )
        return "/assets/information/regime/REG_ALIM_DEFAUT_STANDARD.svg";
      else if (
        this.enfant
          .getRegimeAlimentaireIndividu()
          .getVieQuoRegimeAli()
          .getType_regime() === "Sans poisson"
      )
        return "/assets/information/regime/REG_ALIM_SANS_POISSON.svg";
      else return "/assets/information/regime/REG_ALIM_AUTRE_LISTE_NOM.svg";
    },
  },
  watch: {},
});
